import { NO_KITCHEN_ISLAND_ID, KITCHEN_ISLAND_ID } from "./generators/kitchenIslands";

export function calculateWallEdgingStripLength(plannedShape, wallLocations, kitchenIslandSplashbackSelected) {
  if (plannedShape.getIn(['value', 'id']) === KITCHEN_ISLAND_ID && !kitchenIslandSplashbackSelected || plannedShape.getIn(['value', 'id']) === NO_KITCHEN_ISLAND_ID) {
    return 0;
  }
  const m = plannedShape.get('measurements');
  return wallLocations.reduce((length, wall) => length + m.get(wall), 0);
}

export function calculateWallPanelLength(plannedShape, wallLocations, thickness, kitchenIslandSplashbackSelected) {
  if (plannedShape.getIn(['value', 'id']) === KITCHEN_ISLAND_ID && !kitchenIslandSplashbackSelected || plannedShape.getIn(['value', 'id']) === NO_KITCHEN_ISLAND_ID) return 0;
  if (wallLocations.size === 0 || !thickness) return 0;
  const shapeMeasurements = plannedShape.get('measurements');
  switch (plannedShape.getIn(['value', 'id'])) {
    case 'ii-shape': {
      const corners = getIIShapeCorners(wallLocations);
      return getTotalLength(shapeMeasurements, wallLocations, thickness, corners);
    }
    case 'c-shape': {
      const corners = wallLocations.size - 3;
      return getTotalLength(shapeMeasurements, wallLocations, thickness, corners, 4);
    }
    case 'irregular': {
      const angledCorners = (wallLocations.size - 1) * 2;
      return getTotalLength(shapeMeasurements, wallLocations, thickness, 0, angledCorners);
    }
    default: {
      const corners = wallLocations.size - 1;
      return getTotalLength(shapeMeasurements, wallLocations, thickness, corners);
    }
  }
}

function getTotalLength(shapeMeasurements, wallLocations, thickness, corners, angledCorners = 0) {
  const totalLength = wallLocations.reduce((total, wallLocation) => total + shapeMeasurements.get(wallLocation), 0);
  const thicknessInAngledCorner = Math.ceil(0.4142 * thickness);
  return totalLength - (corners * thickness) - (angledCorners * thicknessInAngledCorner);
}

function getIIShapeCorners(wallLocations) {
  if (wallLocations.size === 6) {
    return 4;
  }
  if (wallLocations.size === 4) {
    return 2;
  }
  if (wallLocations.size === 3) {
    if (['b', 'c', 'd'].every((wallLocation) => wallLocations.includes(wallLocation))) {
      return 1;
    } else {
      return 2;
    }
  } else {
    return 0;
  }
}
